/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

/**
 * Describes the team type for a beneficiary
 */
export enum BeneficiaryTeamType {
  CHARITY = "CHARITY",
  INDIVIDUAL = "INDIVIDUAL",
  ORGANIZATION = "ORGANIZATION",
}

/**
 * Order by values for the brand directory.
 */
export enum BrandDirectoryOrderBy {
  GIVE_DESC = "GIVE_DESC",
  NAME_ASC = "NAME_ASC",
  NEWEST_DESC = "NEWEST_DESC",
  POPULARITY_DESC = "POPULARITY_DESC",
}

/**
 * Describes the brand name of a credit card.
 */
export enum CardTypeEnum {
  AMERICAN_EXPRESS = "AMERICAN_EXPRESS",
  MASTERCARD = "MASTERCARD",
  VISA = "VISA",
}

/**
 * Describes the style of a collection.
 */
export enum CollectionStyle {
  BANNER = "BANNER",
  BANNER_CAROUSEL = "BANNER_CAROUSEL",
  BRAND_CAROUSEL = "BRAND_CAROUSEL",
  CAROUSEL = "CAROUSEL",
  COLLAGE = "COLLAGE",
  CONTENT = "CONTENT",
  DEPARTMENT_GRID = "DEPARTMENT_GRID",
  FEATURED = "FEATURED",
  FOUR_UP = "FOUR_UP",
  GRID = "GRID",
  GRID_HALF_BANNER = "GRID_HALF_BANNER",
  GRID_QUARTER_BANNER = "GRID_QUARTER_BANNER",
  NEARBY_BRANDS = "NEARBY_BRANDS",
  PLAYLIST = "PLAYLIST",
  SINGLE = "SINGLE",
  STORE_FRONT = "STORE_FRONT",
  THREE_UP = "THREE_UP",
  TWO_UP = "TWO_UP",
}

/**
 * What is the source of these coordinates?
 */
export enum CoordinatesSource {
  CAMPAIGN = "CAMPAIGN",
  CURRENT = "CURRENT",
  SEARCH = "SEARCH",
}

/**
 * The list the countries available.
 */
export enum Country {
  CANADA = "CANADA",
  USA = "USA",
}

/**
 * The list of currencies available.
 */
export enum Currency {
  CAD = "CAD",
  USD = "USD",
}

/**
 * Describes the type of a StoreFront, used specifically for querying the different default StoreFronts.
 */
export enum DefaultStoreFrontType {
  HOME_DEFAULT = "HOME_DEFAULT",
  ONBOARDING_DEFAULT = "ONBOARDING_DEFAULT",
  STORE_DEFAULT = "STORE_DEFAULT",
}

/**
 * How this denomination will be deliveried
 */
export enum GiftcardDenominationDeliveryMethod {
  DIGITAL = "DIGITAL",
  PHYSICAL = "PHYSICAL",
}

/**
 * Describes the category of an intent.
 */
export enum IntentCategoryEnum {
  ALL = "ALL",
  BONUS = "BONUS",
  DONATION = "DONATION",
  SHOPPING = "SHOPPING",
}

/**
 * Describes the type of filters available for intent.
 */
export enum IntentFilterByEnum {
  PENDING = "PENDING",
  SUPPORTED = "SUPPORTED",
}

/**
 * Describes the browser that was used to view an intent on mobile.
 */
export enum IntentMobileBrowserTypeEnum {
  APP_BUTTON = "APP_BUTTON",
  APP_CHROME = "APP_CHROME",
  APP_CHROME_ESCAPE = "APP_CHROME_ESCAPE",
  APP_FLIPGIVE_WEBVIEW = "APP_FLIPGIVE_WEBVIEW",
  APP_SAFARI = "APP_SAFARI",
  APP_SAFARI_ESCAPE = "APP_SAFARI_ESCAPE",
}

/**
 * Describes the type of an intent.
 */
export enum IntentTypeEnum {
  BUY = "BUY",
  DONATION = "DONATION",
  FLIPGIVECREDIT = "FLIPGIVECREDIT",
  LINKEDCARDSALE = "LINKEDCARDSALE",
  SHOP = "SHOP",
  TRANSFER = "TRANSFER",
}

/**
 * Describes the type of store link.
 */
export enum LinkType {
  BRAND = "BRAND",
  DEPARTMENT = "DEPARTMENT",
  EMPYR = "EMPYR",
  GIFTCARDOFFER = "GIFTCARDOFFER",
  PRODUCT = "PRODUCT",
}

/**
 * Describes the type of store link available for filtering locations by.
 */
export enum LocationSearchLinkType {
  EMPYR = "EMPYR",
  GIFTCARDOFFER = "GIFTCARDOFFER",
}

/**
 * Describes the department of a merchant.
 */
export enum MerchantDepartmentType {
  FASHION_BEAUTY = "FASHION_BEAUTY",
  FOOD_GROCERIES = "FOOD_GROCERIES",
  GADGETS_ELECTRONICS = "GADGETS_ELECTRONICS",
  GENERAL_RETAIL = "GENERAL_RETAIL",
  GIFTS_SPECIALTY = "GIFTS_SPECIALTY",
  HOME_OFFICE = "HOME_OFFICE",
  LOCAL = "LOCAL",
  RESTAURANT_DINING = "RESTAURANT_DINING",
  SERVICES_UTILITIES = "SERVICES_UTILITIES",
  SPORTS_OUTDOOR = "SPORTS_OUTDOOR",
  TRAVEL_ENTERTAINMENT = "TRAVEL_ENTERTAINMENT",
}

/**
 * Describes the status of missing claim.
 */
export enum MissingClaimStatusEnum {
  APPROVED = "APPROVED",
  AUTO_CLOSED = "AUTO_CLOSED",
  DENIED = "DENIED",
  PENDING = "PENDING",
}

/**
 * Describes the payment types that can be used for beneficiary
 */
export enum PaymentType {
  EMAIL = "EMAIL",
  HW_BANK_TRANSFER = "HW_BANK_TRANSFER",
  HW_CHECK = "HW_CHECK",
  POSTAGE = "POSTAGE",
}

/**
 * Describes the platform of a device.
 */
export enum PlatformEnum {
  ANDROID = "ANDROID",
  IOS = "IOS",
  WEB = "WEB",
  WEB_ANDROID = "WEB_ANDROID",
  WEB_EXTENSION = "WEB_EXTENSION",
  WEB_IOS = "WEB_IOS",
}

/**
 * The privacy level that describes how much information about an object is shared.
 */
export enum PrivacyLevel {
  HIGH = "HIGH",
  LOW = "LOW",
  MEDIUM = "MEDIUM",
}

/**
 * Attributes for creating a beneficiary for a campaign
 */
export interface BeneficiaryCreateInput {
  campaignId: string;
  city: string;
  contactName?: string | null;
  country: Country;
  dateOfBirth?: string | null;
  email: string;
  firstName?: string | null;
  googlePlacesId?: string | null;
  lastName?: string | null;
  legalName: string;
  paymentType: PaymentType;
  phoneNumber: string;
  plaidAccountId?: string | null;
  plaidPublicToken?: string | null;
  postalCode: string;
  province: string;
  realTeamName: string;
  street1: string;
  street2?: string | null;
  taxId?: string | null;
  teamName?: string | null;
  teamType: BeneficiaryTeamType;
  website?: string | null;
}

/**
 * Attributes for updating a beneficiary for a campaign
 */
export interface BeneficiaryUpdateInputType {
  city?: string | null;
  contactName?: string | null;
  country?: Country | null;
  dateOfBirth?: string | null;
  email?: string | null;
  firstName?: string | null;
  googlePlacesId?: string | null;
  id: string;
  lastName?: string | null;
  legalName?: string | null;
  paymentType?: PaymentType | null;
  phoneNumber?: string | null;
  plaidAccountId?: string | null;
  plaidPublicToken?: string | null;
  postalCode?: string | null;
  province?: string | null;
  realTeamName?: string | null;
  street1?: string | null;
  street2?: string | null;
  taxId?: string | null;
  teamName?: string | null;
  teamType?: BeneficiaryTeamType | null;
  website?: string | null;
}

/**
 * Attributes for processing a gift card transaction
 */
export interface BuyProcessInput {
  shouldCreateAccount?: boolean | null;
  shouldSaveCard?: boolean | null;
  stripeCardId?: string | null;
  stripeTokenId?: string | null;
  stripeVerificationCode?: string | null;
}

/**
 * Attributes for updating an gift card Intent
 */
export interface BuyUpdateInput {
  buyerEmail?: string | null;
  buyerName?: string | null;
  city?: string | null;
  country?: string | null;
  deliverOn?: any | null;
  giftEmail?: string | null;
  giftMessage?: string | null;
  giftName?: string | null;
  giftcardTemplateId?: string | null;
  isAnonymous?: boolean | null;
  postalCode?: string | null;
  province?: string | null;
  shippingOption?: string | null;
  shouldSaveAddress?: boolean | null;
  street1?: string | null;
  street2?: string | null;
}

/**
 * Coordinates attributes
 */
export interface CoordinatesInput {
  latitude: number;
  longitude: number;
  source?: CoordinatesSource | null;
}

/**
 * Attributes for updating an event.
 */
export interface EventUpdateInput {
  brandId?: string | null;
  brandLocationId?: string | null;
  description?: string | null;
  endsAt?: string | null;
  eventId: string;
  name?: string | null;
  startsAt?: string | null;
}

/**
 * Attributes for creating a giftcard intent
 */
export interface GiftcardIntentCreateInput {
  amountCents: number;
  deviceAttributes: IntentDeviceAttributesInput;
  fundraiserId?: string | null;
  isGift: boolean;
  isPhysical: boolean;
  linkId: string;
  quantity: number;
}

/**
 * Information about the device making the intent
 */
export interface IntentDeviceAttributesInput {
  devicePlatform: PlatformEnum;
  deviceType?: string | null;
  deviceVersion?: string | null;
  ipAddress?: string | null;
  mobileBrowserType?: IntentMobileBrowserTypeEnum | null;
  userAgent?: string | null;
}

/**
 * Attributes for leaving a campaign
 */
export interface LeaveCampaignInput {
  campaignId: string;
  userId: string;
}

/**
 * Attributes for creating an organization
 */
export interface OrganizationInput {
  categoryId: string;
  city: string;
  country: Country;
  legalName: string;
  name: string;
  postalCode: string;
  province: string;
  street1: string;
}

/**
 * Attributes for adding multiple favorite brands
 */
export interface ViewerAddFavoriteBrandsInput {
  brandIds: string[];
}

/**
 * Input for answering a user onboarding question
 */
export interface ViewerAnswerOnboardingQuestionInput {
  answerID: string;
  questionID: string;
}

/**
 * Attributes for generating a payment breakdown/report
 */
export interface ViewerEmailPaymentBreakdownInput {
  paymentId: string;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
